import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import list from '@/components/list'
import details from '@/components/details'
import baobiao from '@/components/baobiao'

import search from '@/components/search'
import login from '@/components/login'
import bindTel from '@/components/login_bind'
import auth from '@/components/auth'
import transfer from '@/components/transfer'
import selfinfo from '@/components/selfInfo'
import collectlist from '@/components/collectlist'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      //name: 'transfer',
      name: 'home1',//todo new 20260212name必须唯一
      component: transfer,
      meta: {
        title: "实习进修胜任力平台",
      }
    },
    {
      path: '/transfer',
      name: 'transfer',
      component: transfer,
      meta: {
        title: "实习进修胜任力平台",
      }
    },
    {
      path: '/auth',
      name: 'auth',
      component: auth,
      meta: {
        title: "实习进修胜任力平台",
      }
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: {
        title: "实习进修胜任力平台",
      }
    },
    {
      // path: '/list/:id',
      path: '/list',
      name: 'list',
      component: list
    },
    {
      path: '/details',
      name: 'details',
      component: details
    },
    {
      path: '/baobiao',
      name: 'baobiao',
      component: baobiao
    },
    {
      path: "/search",
      name: "search",
      component: search,
      meta: {
          title: "搜索",
      },
  },
  {
      path: "/login",
      name: "login",
      component: login,
      meta: {
          title: "实习进修胜任力平台",
      },
  },
  {
      path: "/bindTel",
      name: "bindTel",
      component: bindTel,
      meta: {
          title: "绑定手机号",
      },
  },
  {
      path: "/selfinfo",
      name: "selfinfo",
      component: selfinfo,
      meta: {
          title: "个人中心",
      },
  },
  {
      path: "/collectlist",
      name: "collectlist",
      component: collectlist,
      meta: {
          title: "",
      },
  }
  ],
})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js